const MenuAluno = [
    {
        heading: 'Menu Aluno',
        translate: 'sidebar.heading.HEADER.Aluno'
    },
    {
        name: 'Home',
        icon: 'fa fa-home',
        path: '/senhas'
    },
    {
        name: 'Dados Próprios',
        translate: 'menu.DadosProprios',
        icon: 'fa fa-user',
        submenu: [{
            name: 'Meus Dados',
            translate: 'menu.MeusDados',
            path: '/dadospessoaisalu'
        },{
            translate: 'menu.TrocarSenha',
            name: 'Trocar Senha',
            path: '/trocarsenha'
        }]
    },
];

export default MenuAluno;
